import useTracking from './useTracking';
import useGA4Tracking from './trackers/useGA4Tracking';

const {
  track,
  addTracker,
  trackFormSubmit,
  trackFormConversion,
  trackFormError,
  trackFormStep,
  trackLinkClick,
  trackLinkClicks,
  trackLinkImpression,
  trackLinkImpressions,
  trackLanguageChange,
} = useTracking({
  // DO NOT COMMIT WITH DEBUG ENABLED
  // debug: true,
});

// Add GA4 tracker
addTracker(useGA4Tracking());

// Global tracking
const init = () => {
  trackLinkClicks('a[data-tx]');
  trackLinkImpressions('a[data-tx]');
};

export default init;

export {
  track,
  addTracker,
  trackFormSubmit,
  trackFormConversion,
  trackFormError,
  trackFormStep,
  trackLinkClick,
  trackLinkClicks,
  trackLinkImpression,
  trackLinkImpressions,
  trackLanguageChange,
};
